import React from 'react'
import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

// data => ['header1', 'header2', ...]
// columns => [{ id: 'id', style: { width: '100px' }, value: 'value' }, ...}}]

export default function TableComponent({ data, columns }) {
  const renderValues = (values) => (
    <TableRow key={JSON.stringify(values)}>
      {
        values.map((value) => (
          <TableCell key={value.id} style={value.style}>
            {value.value}
          </TableCell>
        ))
      }
    </TableRow>
  )

  return (
    <Table>
      <TableHead>
        <TableRow>
          {data.map((item) => (<TableCell key={item}>{item.toUpperCase()}</TableCell>))}
        </TableRow>
      </TableHead>
      <TableBody>
        {columns.map(renderValues)}
      </TableBody>
    </Table>
  )
}

TableComponent.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
}
